import { STRAPI_URL, parseErrorMessage, strapiAuthHeaders } from './strapi';
import {
  strapiCreateDynamicEntity,
  strapiDeleteDynamicEntity,
  strapiUpdateDynamicEntity,
  type DynamicEntityRow,
  normalizeDynamicRow,
} from './strapiDynamicEntity';

function asRecord(v: unknown): Record<string, unknown> | null {
  if (typeof v !== 'object' || v === null || Array.isArray(v)) return null;
  return v as Record<string, unknown>;
}

function parseListBody(res: Response, body: unknown): Record<string, unknown>[] {
  if (!res.ok) throw new Error(parseErrorMessage(body, res.status));
  if (Array.isArray(body)) return body as Record<string, unknown>[];
  const b = asRecord(body);
  if (b && Array.isArray(b.data)) return b.data as Record<string, unknown>[];
  return [];
}

const API = 'quotation-logs';
const POPULATE = '*';

export async function strapiListQuotationLogsForQuotation(
  jwt: string,
  quotationDocumentId: string,
): Promise<DynamicEntityRow[]> {
  const params = new URLSearchParams({
    'pagination[pageSize]': '200',
    'pagination[page]': '1',
    sort: 'updatedAt:desc',
    populate: POPULATE,
    'filters[quotation][documentId][$eq]': quotationDocumentId,
  });
  const res = await fetch(`${STRAPI_URL}/api/${API}?${params}`, { headers: strapiAuthHeaders(jwt) });
  const body = await res.json().catch(() => ({}));
  return parseListBody(res, body).map((r) => normalizeDynamicRow(r));
}

export async function strapiCreateQuotationLogForQuotation(
  jwt: string,
  quotationDocumentId: string,
  change_logs: unknown,
): Promise<DynamicEntityRow> {
  return strapiCreateDynamicEntity(
    jwt,
    API,
    {
      change_logs,
      quotation: { connect: [quotationDocumentId] },
    },
    POPULATE,
  );
}

export async function strapiUpdateQuotationLog(
  jwt: string,
  documentId: string,
  change_logs: unknown,
): Promise<DynamicEntityRow> {
  return strapiUpdateDynamicEntity(jwt, API, documentId, { change_logs }, POPULATE);
}

export async function strapiDeleteQuotationLog(jwt: string, documentId: string): Promise<void> {
  return strapiDeleteDynamicEntity(jwt, API, documentId);
}
